import React, { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FiltersPopupContextProvider } from '@vms/FiltersPopup/FiltersPopupContext';
import ScrollTopButton from '@vms/Layout/ScrollTopButton';
import { PlatformNavigation } from "@datassential/platform-ui-lib";
import PlatformHeader from "@vms/PlatformHeader";

const Layout: FC = () => {
    const location = useLocation();

    useEffect(() => {
        document.scrollingElement?.scrollTo({ top: 0 })
    }, [location])

    return (
        <div className="Layout">
            <FiltersPopupContextProvider>
                <PlatformNavigation/>
                <PlatformHeader/>
                <Outlet/>
                <ScrollTopButton/>
            </FiltersPopupContextProvider>
        </div>
    );
}

export default Layout;